import { motion } from 'motion/react';
import { LabsHeaderContainer } from './labs-header-container';

interface LabsHeaderErrorProps {
  onTryAgain: () => void;
  onContactSupport: () => void;
  className?: string;
}

export function LabsHeaderError({ onTryAgain, onContactSupport, className }: LabsHeaderErrorProps) {
  return (
    <LabsHeaderContainer className={className}>
      <div className="flex min-h-[250px] flex-col justify-center">
        <motion.h1
          className="mb-4 text-center text-2xl font-bold leading-tight text-white md:text-left md:text-[44px] md:font-normal md:leading-[56px] md:tracking-[0.3px]"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          There was an issue with your order
        </motion.h1>

        <motion.p
          className="mb-8 max-w-[900px] text-[20px] font-normal leading-[1.3] text-white"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Please contact our support team so we can review your order and get things back on track. We'll make sure your
          lab visit is processed correctly and keep you updated once it's resolved.
        </motion.p>

        <motion.div
          className="flex flex-wrap gap-3"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <motion.button
            onClick={onTryAgain}
            className="flex h-10 w-fit items-center justify-center rounded-full bg-[#7cf1c7] px-6 text-[14px] font-bold text-[#183344] transition-all hover:opacity-90"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Try Again
          </motion.button>
          <motion.button
            onClick={onContactSupport}
            className="flex h-10 w-fit items-center justify-center rounded-full bg-[#7cf1c7] px-6 text-[14px] font-bold text-[#183344] transition-all hover:opacity-90"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Contact Support
          </motion.button>
        </motion.div>
      </div>
    </LabsHeaderContainer>
  );
}
